const styles = (theme) => ({
	paperFluxo: {
		borderRadius: "16px",
		flex: 1,
		height: "100%",
		overflowY: "auto",
		position: "relative",
		height: "744px",

		height: "83vh",
		"@media (max-width: 750px)": {
			width: "100vw",
			overflowX: "hidden",
		},
	},
});

export default styles;
